import React from "react";

function DoubleFunToken() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.8315 2.177C17.6659 -0.725665 22.3341 -0.725665 25.1685 2.177L26.7231 3.76909L28.9481 3.74258C33.0048 3.69426 36.3057 6.99522 36.2574 11.0519L36.2309 13.2769L37.823 14.8315C40.7257 17.6659 40.7257 22.3341 37.823 25.1685L36.2309 26.7231L36.2574 28.9481C36.3057 33.0048 33.0048 36.3057 28.9481 36.2574L26.7231 36.2309L25.1685 37.823C22.3341 40.7257 17.6659 40.7257 14.8315 37.823L13.2769 36.2309L11.0519 36.2574C6.99522 36.3057 3.69426 33.0048 3.74258 28.9481L3.76909 26.7231L2.177 25.1685C-0.725665 22.3341 -0.725665 17.6659 2.177 14.8315L3.76909 13.2769L3.74258 11.0519C3.69426 6.99522 6.99522 3.69426 11.0519 3.74258L13.2769 3.76909L14.8315 2.177ZM27.7778 14.1667C27.7778 16.4679 25.9123 18.3333 23.6111 18.3333C21.3099 18.3333 19.4444 16.4679 19.4444 14.1667C19.4444 11.8655 21.3099 10 23.6111 10C25.9123 10 27.7778 11.8655 27.7778 14.1667ZM16.6667 25.2778C16.6667 26.6667 18.0556 26.6667 18.0556 26.6667H29.1667C29.1667 26.6667 30.5556 26.6667 30.5556 25.2778C30.5556 23.8889 29.1667 19.7222 23.6111 19.7222C18.0556 19.7222 16.6667 23.8889 16.6667 25.2778ZM15.5783 26.6667C15.3827 26.2721 15.2778 25.8044 15.2778 25.2778C15.2778 23.3952 16.2209 21.4591 17.9666 20.1111C17.2029 19.8668 16.3126 19.7222 15.2778 19.7222C9.72222 19.7222 8.33333 23.8889 8.33333 25.2778C8.33333 26.6667 9.72222 26.6667 9.72222 26.6667H15.5783ZM18.0556 14.8611C18.0556 16.7788 16.501 18.3333 14.5833 18.3333C12.6657 18.3333 11.1111 16.7788 11.1111 14.8611C11.1111 12.9435 12.6657 11.3889 14.5833 11.3889C16.501 11.3889 18.0556 12.9435 18.0556 14.8611Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default DoubleFunToken;
